import { useContext } from "react";
import ReactPlayer from "react-player";
import TimelinePlayerContext from "../context/TimelinePlayerContext";

/** Publishes BasicPlayer's ReactPlayer instance into TimelinePlayerContext. */
export default function useOnReady(
  onReady?: (player: ReactPlayer | undefined) => void,
) {
  const { setPlayer } = useContext(TimelinePlayerContext);

  return (player: ReactPlayer | undefined) => {
    setPlayer(player);
    onReady?.(player);
  };
}
